import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import { CrossBoldIcon } from '../../Icons/Miscellaneous/CrossBold'
import styles from './ListItemCross.module.scss'

export const ListItemCross: FunctionComponent<Props> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <li className={classnames(styles.listItemCross, className)} {...rest}>
      <CrossBoldIcon
        className={styles.listItemCrossIcon}
        data-testid="list-cross-icon"
      />
      <span>{children}</span>
    </li>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  className?: string
  children: ReactNode
} & HTMLProps<HTMLLIElement>
